

export default function TerminosContent() {
    return (
        <div className="container accordions ptb-50">
            <p>ÍNDICE</p>
            <p>1.Quienes somos</p>
            <p>1. a Quienes somos.</p>
            <p>1. b ¿Cómo funciona Hotmy?</p>
            <p>c Terminología específica</p>
            <p>2. Términos de uso generales</p>
            <p>2.a Registración</p>
            <p>2. b Veracidad de datos declarados</p>
            <p>2. c Condiciones de registración: Mayoría de edad</p>
            <p>2. d ¿Cómo funciona HOTMY?</p>
            <p><strong>HOTMER</strong></p>
            <p>Feed de suscripción</p>
            <p>VISUALIZADOR</p>
            <p>2. e Tu compromiso al momento de la registración.</p>
            <p>2. f Nuestro compromiso…</p>
            <p>2. g ¿Cómo te das de baja?</p>
            <p>3. Términos de uso de los “creadores de contenido”</p>
            <p>3. a Material “prohibido”</p>
            <p>3. b Sanciones</p>
            <p>3. c Pagos</p>
            <p>3. d Obligaciones del creador de contenido/HOTMER</p>
            <p>3. e Derechos del creador de contenido</p>
            <p>4. Términos de uso de los “visualizadores”</p>
            <p>4. a Abonos</p>
            <p>4. b Acceso al material</p>
            <p>4. c Prohibiciones</p>
            <p>4. d Sanciones en caso de violaciones a las prohibiciones.</p>
            <p>4. e Obligaciones del visualizador</p>
            <p>4. f Derechos del Visualizador</p>
            <p>5. Relaciones externas con Hotmy</p>
            <p>5. a Enlaces</p>
            <p>5. b Términos del programa de Referidos</p>
            <p>5. c Reglas del programa de Recomendación Hotmy</p>
            <p>5. d Pagos por recomendación</p>
            <p>5. e Nuestros derechos relacionados con el programa de recomendación</p>
            <p>6. Nosotros</p>
            <p>6. a Jurisdicción en caso de disputas</p>
            <p>6. b Cargas impositivas</p>
            <p>6. c ¿ De qué no somos responsables?</p>
            <p>6. d Protección de datos personales</p>
            <p>6. e Nuestros derechos…</p>
            <p>6. f Tipo de cambio</p>
            <p>6. g Medios de pago. Demoras</p>
            <p>7. Reclamos o quejas</p>
            <p>7. a ¿Cómo realizo un reclamo o queja?</p>
            <p>7. b Quejas injustificadas, abusivas o falsas</p>
            <p></p>
            <p>Términos y condiciones del servicio</p>

            <h1>1.Quienes somos</h1>



            <h2>1. a Quienes somos.</h2>



            <p> Somos Hotmy, una LCC registrada en Estados Unidos. Para contactarnos podés enviarnos un correo electrónico a nuestro equipo de soporte a <a href="mailto:info@hotmy.app">info@hotmy.app</a> .</p>



            <h2>1. b ¿Cómo funciona Hotmy?</h2>



            <p>Hotmy, es una aplicación móvil web que permite la comercialización de suscripciones mensuales y paquetes de contenido multimedia de pago único. Gestiona la subida de contenido multimedia, ya sea fotos o videos y mediante un sistema de comisión por cada una de las transacciones realizadas por los clientes.</p>



            <p>El creador de contenido Hotmer y Hotmy generan ingresos. Destinada a usuarios que quieren monetizar su imagen.</p>



            <p>La app tiene integración con plataformas de pago locales e internacionales y un sistema de referidos.</p>



            <h2>1c Terminología específica</h2>



            <p>Los siguientes términos de uso regirán para todos los usuarios de HOTMY y su acuerdo con nosotros.</p>



            <p>Términos de servicio:</p>



            <p>– Nos referimos a nuestra Aplicación web como “Hotmy”, incluso cuando se accede a través de la URL www.hotmy.app o mediante cualquier navegador web;</p>



            <p>– cuando nos referimos a “nosotros”, “nuestro”, “nos” hacemos alusión a Hotmy LCC, el operador de Hotmy;</p>



            <p>– “Contenido” significa cualquier material subido a Hotmy por cualquier Usuario ya sea un Creador o un Visualizador, incluidas fotos, videos, audio por ejemplo, música y otros sonidos, material de transmisión en vivo, datos, texto como comentarios y hashtags, metadatos, imágenes, funciones interactivas, emojis, GIF, memes y cualquier otro material;</p>



            <p>– “Hotmer/ creador” se denomina a un Usuario que ha configurado su cuenta de Hotmy como una cuenta de Creador, para publicar Contenido en Hotmy y que pueda ser visualizado por otros Usuarios;</p>



            <p>– “Visualizador” se denomina a un Usuario que sigue a un Hotmer y puede ver el Contenido del Creador;</p>



            <p>– “Pago de Visualizador” significa todos y cada uno de los pagos realizados por un Visualizador a un Hotmer, incluidos los pagos por acceso al Contenido, para la interacción, para obtener nuevo Contenido, para suscribirse a la cuenta de un Hotmer o, para usar la función de interacción con los Visualizadores en la cuenta del Hotmer y cualquier propina pagada por un Visualizador al Hotmer.</p>



            <p>– Cuando hablamos de “Feed”, nos estamos refiriendo a muro, en el cual se cargará el contenido.</p>



            <p>– “Referidos” significa un Usuario que participa en el Programa de Referencias de Hotmy;</p>



            <p>– “Contrato estándar entre Visualizador y Hotmer” hace referencia a los términos que rigen cada transacción entre un Visualizador y un creador en Hotmy , que se pueden encontrar aquí ;</p>



            <p>– “Usuario” significa cualquier usuario de Hotmy, ya sea un Hotmer o un Visualizador o ambos también conocido como “usted”, “su” o “vos”.</p>



            <h1>2. Términos de uso generales</h1>



            <h2>2.a Registración</h2>



            <p>Los usuarios tanto los creadores de contenido HOTMER como los Visualizadores, podrán descargar la app y crear un perfil gratuito, sin costos de creación ni de mantenimiento.</p>



            <p>Los datos que se te van a solicitar, si sos usuario VISUALIZADOR son: Nombre + Email + contraseña + repetir contraseña. Estos, son para poder tener un nombre que verás en tu menú de datos, y el correo y contraseña para poder loguearte en caso de cerrar la sesión activa.</p>



            <p>Los datos que se te van a solicitar si sos usuario CREADOR DE CONTENIDO además de los requeridos para generar el perfil de visualizador serán algunos adicionales para validar el perfil de Hotmer Nombre de Hotmer , Nombre y apellido, Nacionalidad, Fecha de Nacimiento, Género, Tipo de Rol, Instagram.</p>



            <p>Además, para poder subir contenido, deberás cargar: foto frente y dorso del Documento de Identidad para validar ser mayor de edad y veracidad de datos, Selfie con el Documento de Identidad para confirmar la persona física es la misma que las fotos del Documento de Identidad y para evitar perfiles falsos con documentación ajena.</p>



            <p>Vale aclarar, que quien adjunta estos archivos, tiene que ser la misma persona que aparezca en las fotos, videos y demás contenido.</p>



            <p>Queda prohibida la aparición en el contenido de otras personas, siempre que no tengan un perfil ya creado en la aplicación y validados como creadores de contenido.</p>



            <p>Está terminantemente prohibido la aparición en cualquier contenido, de menores de edad.</p>



            <p>Detalle de los datos solicitados en caso de ser CREADOR DE CONTENIDO</p>



            <ul><li>Nombre de Hotmer: Puede ser un nombre de fantasía o el real. Verificá que tu nombre Hotmer, no esté protegido por la ley de Propiedad intelectual. Desde Hotmy no nos responsabilizamos en caso de contiendas legales a raíz de la utilización de tu nombre de Hotmer</li><li>Género: Sirve para que los visualizadores puedan filtrar el tipo de género que les gustaría ver.</li><li>Instagram: Sirve como medio de contacto y a fines estadísticos.</li><li>Tipo de Rol: Modelo, Agencia o Fotógrafo Opciones disponibles, indican que tipo de rol vas a querer en la plataforma.</li></ul>



            <p>Los únicos datos que son vistos por los visualizadores es el NOMBRE HOTMER.</p>



            <p>Los perfiles de Visualizadores no podrán ser encontrados en la aplicación estarán ocultos. Sólo se podrá visualizar la foto de perfil de los creadores de contenido y portada completa.</p>



            <h2>2. b Veracidad de datos declarados</h2>



            <p>Al registrarte en Hotmy, estás declarando que los datos proporcionados son precisos, veraces, completos y la documentación presentada efectivamente es de tu propiedad. Por ello, consideramos que la información brindada es veraz y completa, no responsabilizándonos por todos aquellos daños y perjuicios derivados y/u ocasionados por la falsedad, vaguedad o deficiencia de los datos declarados, o por los delitos que incurran quienes los declaren o terceros.</p>



            <h2>2. c Condiciones de registración: Mayoría de edad</h2>



            <p>Para poder registrarte en Hotmy, como CREADOR DE CONTENIDO o VISUALIZADOR, debés cumplir con la totalidad de los siguientes requisitos:</p>



            <ul><li>Ser mayor de edad, conforme a la legislación vigente en tu país de residencia actual.</li><li>Contar con la documentación fehaciente que se requiere para la registración – VER PUNTO 2. A-</li></ul>



            <p> Cabe aclarar que HOTMY no define la calificación de edad mínima requerida para poder descargar la App. Esto es definido según los parámetros de <a href="https://pegi.info/es">h</a><a href="https://pegi.info/es">ttps://pegi.info/es</a>. Puede variar según el país. Por ello, no somos responsables ni tenemos incidencia en dicha calificación, ni tampoco si personas menores de edad pueden acceder a ella por medio de las diferentes tiendas.</p>



            <h2>2. ¿Cómo funciona HOTMY?</h2>



            <p> HOTMY, es una aplicación móvil web que permite la comercialización de contenido fotográfico y multimedia a través de las suscripciones mensuales y paquetes de pago único, que funciona como se describe en el <em>punto 1 d</em>.</p>



            <p> HOTMY funciona de la siguiente manera:</p>



            <p> Hay dos tipos de Usuarios: el <em>CREADOR</em> de contenido HOTMER <em>ver punto 3</em> y los <em>VISUALIZADORES ver punto 4</em> que son los que realizan las compras.</p>



            <h3>HOTMER</h3>



            El <em>Hotmer</em>, va a disponer de un “perfil” donde va a poder agregar foto de perfil y foto de portada. No pueden contener imágenes de las vetadas en el <em>apartado 3.</em>. Además, va a tener a disposición:



            <h3><em>Feed de suscripción</em></h3>



            <ul><li>1 Muro para fotos.</li></ul>



            <ul><li>1 Muro para Videos.</li></ul>



            <p><strong><em>Feed de pago único</em></strong><em></em></p>



            <ul><li>1 Feed para Packs / Álbumes</li></ul>



            <p><strong><em>Menú lateral</em></strong></p>



            <p>En él el HOTMER podrá:</p>



            <ul><li>Hacer un seguimiento de su dinero Disponible y su Dinero a Liquidar.</li><li>Editar su perfil <em>Foto perfil, foto portada, Rasgos, valores de Suscripción, sus Datos, Nombre de Usuario, Preferencias de Búsqueda.</em></li><li>Carga de Cuentas MercadoPago y/o PayPal.</li><li>Realizar extracciones.</li><li>Cerrar la sesión.</li><li>Modificar la contraseña.</li><li>Ver su Perfil con las estadísticas <em>Cantidad de Fotos, Videos, Packs, comentarios, me gusta.</em></li></ul>



            <h3>VISUALIZADOR</h3>



            <p>El <em>visualizador</em>, tendrá disponible una cuenta con un perfil donde podrá agregar foto de perfil, la cual no podrá contener imágenes de las vetadas en el <em>apartado 3. a.</em>Además, dispondrá de:</p>



            <p><strong><em>Home</em></strong></p>



            <p>Un MURO PRINCIPAL, en el cual podrá visualizar los perfiles de distintos Hotmers.</p>



            <p><strong><em>Buscador</em></strong>:</p>



            <ul><li>Búsqueda de Perfiles <em>Podrá examinar perfiles escribiendo el nombre del Hotmer</em></li><li>Búsqueda de Packs <em>Podrá buscar Packs con palabras claves y/o también a través de íconos de filtros</em></li></ul>



            <p><strong><em>Mi contenido</em></strong><em></em></p>



            <p>Aquí podrá divisar el contenido que el <em>visualizador </em>compró o en el cual está ya suscripto.</p>



            <p><strong><em>Suscripciones</em></strong></p>



            <p>Contiene las suscripciones que tiene activas.</p>



            <p><strong><em>Packs</em></strong></p>



            <p>Contiene los Packs Comprados.</p>



            <p><strong><em>Lista de deseos</em></strong></p>



            <p>Contenido que el visualizador agregó en la lista de Deseos, el cual podrá consistir en Suscripciones o Packs.</p>



            <p><strong><em>Menú lateral</em></strong></p>



            <p>Podrá editar su perfil, cerrar la sesión, modificar la contraseña, agregar cuentas, ver las notificaciones.</p>



            <h2>2. e Tu compromiso al momento de la registración.</h2>



            <p>A partir del momento que te registrás en Hotmy y pasas a formar parte de nuestra comunidad, asumís con nosotros los siguientes deberes y obligaciones:</p>



            <ul><li>A declarar los datos que sean modificados y que hayan sido brindados en tu registración ej. modificación y/o cambio de nombre, mail o teléfono, cuenta de pagos, etc.</li><li>A no crear más de una cuenta en simultáneo en esta aplicación.</li><li>A mantener tus datos de cuenta contraseñas y/o datos de usuario a resguardo y de manera segura.</li><li>A comunicarte con nosotros a info@hotmy.app en caso de tener algún inconveniente con la aplicación hackeo, bloqueo, hurto de datos o imágenes, etc. Sin embargo, es tu responsabilidad el correcto uso de la misma y la protección de tus datos y contenido de tu cuenta.</li><li>A mantener un trato cordial con el resto de los miembros de la comunidad de Hotmy, y vas a evitar el uso de lenguaje violento, discriminatorio, hacer bullying, acosar verbal o sexualmente a otros miembros, amenazar, agredir o a realizar cualquier tipo de acción que provoque daño en alguno/s de los demás miembros.</li><li>A brindar contenido que sea de tu propiedad.</li><li>Usar HOTMY sólo para uso personal y no vender, alquilar, transferir o compartir tu cuenta o el contenido obtenido de HOTMY.</li><li>A usar HOTMY para un propósito que sea legal.</li><li>A no utilizar la herramienta de “comentarios” para ofrecer servicios sexuales, vender publicidad, drogas o con fines ilícitos.</li><li>A no utilizar las herramientas de HOTMY paraa concretar una venta externa de contenido multimedia, esté o no cargado dicho contenido en la aplicación.</li><li>A no cargar, publicar o mostrar contenido que sea ilegal, fraudulento, difamatorio, discriminatorio, amenazante, acosador, violento o que promueva una actividad ilegal.</li><li>No usar HOTMY de ninguna manera que pueda explotar, dañar, o influir en personas menores de edad.</li><li>No usar HOTMY para acechar, intimidar, abusar, acosar, amenazar o intimidar a otra persona</li><li>No utilizar HOTMY para incurrir en conductas engañosas o que puedan inducir al error o engañar a terceros.</li><li>A respetar los derechos de propiedad intelectual de los HOTMER, no grabar ni reproducir, compartir, comunicar al público, distribuir o divulgar los datos de los HOTMERS o VISUALIZADORES, sin su consentimiento.</li><li>A no suplantar identidad y simular ser un representante de HOTMY, o empleado, u otro usuario, ni declarar, sugerir que HOTMY te respalda o patrocina.</li><li>A no hacer uso no autorizado del contenido de otra personas.</li><li>A no hacer ninguna publicación que sea Spam.</li><li>A no utilizar otros métodos o medios, por ejemplo claves, para infringir nuestras normas.</li><li>A no introducir intencionalmente virus, troyanos, gusanos, bombas lógicas u otro material o contenido que sea malicioso o tecnológicamente dañino.</li><li>A no utilizar HOTMY de una manera que pueda afectar negativamente nuestros sistemas o seguridad o interferir con el uso de HOTMY de cualquier otro usuario.</li><li>A no utilizar ningún programa, herramienta o proceso automatizado para acceder a HOTMY o cualquier servidor, red o sistema asociado con HOTMY, o para extraer, recolectar, cosechar o recolectar contenido o información de HOTMY.</li><li>A no utilizar el nombre, logotipo de HOTMY o cualquier nombre, logotipo, nombre, diseño o lema relacionado o similares.</li></ul>



            <h2>2. f Nuestro compromiso…</h2>



            <p>Nosotros deseamos que logres optimizar al máximo tu contenido y logrés tu máxima monetización. Por ello nos comprometemos a:</p>



            <p>~ Para aquellos perfiles que ingresaron a HOTMY antes del lanzamiento oficial, les otorgaremos un beneficio de posicionamiento, por un plazo de 1 año desde el momento de la registración. Vencido dicho plazo, el posicionamiento se regirá conforme las pautas del apartado 6. f ii.</p>



            <p>~ Abonar los montos acordados por suscripciones, packs y regalos que realicen los VISUALIZADORES a los CREADORES.</p>



            <p>~ A que tengas a disposición por el tiempo acordado, los contenidos de los packs, suscripciones y que el CREADOR reciba el regalo que le hayas enviado.</p>



            <p>~ A respetar todos los derechos otorgados a los CREADORES y VISUALIZADORES, reconocidos en el presente TÉRMINOS Y CONDICIONES.</p>



            <p>~ A realizar las comunicaciones de cambio de política de uso, baja de servicios, nuevas funciones, actualización de tarifas y todas aquellas que consideremos necesarias, dentro de la Aplicación de HOTMY, y que las mismas se consideren fehacientes.</p>



            <p>~ A comunicar al HOTMER cuando su material haya sido seleccionado por nosotros con fines publicitarios.</p>



            <h2>2. g ¿Cómo te das de baja?</h2>



            <p>Si deseas eliminar tu cuenta de Hotmy, puedes hacerlo en la sección ‘Perfil de usuario’ – Opción de Eliminar Cuenta Hotmy.</p>



            <ol type="a"><li>Si sos un <em>Visualizador</em>, la eliminación de tu cuenta se llevará a cabo dentro de un tiempo razonable después de tu solicitud de Baja.</li><li>Si sos un <em>Hotmer</em>, una vez que inicies el proceso de “eliminar cuenta”, tu cuenta permanecerá abierta hasta el último día del período de suscripción paga de tus Visualizadores, quedando el saldo a favor de Hotmy y tu cuenta será eliminada.</li><li>Una vez que se haya eliminado tu cuenta, no se te cobrará ningún monto adicional ni tendrás acceso a tu cuenta anterior de Hotmy o tu Contenido, y las suscripciones se eliminarán y no podrán renovarse posteriormente.El contenido de Packs quedará disponible luego de la baja de la cuenta Hotmer para el usuario que realizó la compra previa del contenido multimedia de pago único.</li><li>Recibirás una confirmación por correo electrónico después de la eliminación exitosa de tu cuenta.Una vez que se haya eliminado, podemos tratar tu Contenido de la manera adecuada incluso podremos eliminarla y ya no tendrás derecho a acceder a tu Contenido.No existe ninguna función disponible en Hotmy para que puedas acceder a tu Contenido después de la cancelación de tu cuenta.</li></ol>



            <h1>3. Términos de uso de los “creadores de contenido”</h1>



            <h2>3. a Material “prohibido”</h2>



            <p> En HOTMY, no podrás utilizar, publicar, cargar ni mostrar de manera directa o indirecta, ningún tipo de contenido que:</p>



            <p>i. muestre, incluya o haga referencia a: Personas menores de edad conforme las normas de mayoría de edad de tu país de residencia o cualquier otra persona, a menos que poseas documentación escrita y firmada que confirme que todas las personas mostradas, mencionadas o incluídas en tu contenido son mayores de edad, y que brinden su consentimiento para utilizar su nombre y/o imagen, o que sean HOTMER y se trate de un material conjunto.</p>



            <p>ii. muestres, promociones, promuevas, incites o hagas referencia a:</p>



            <p> ~ armas de fuego, armas o cualquier elemento cuya venta, posesión, tenencia o uso esté fuera del comercio o prohibido o restringido por las leyes de tu país de residencia.</p>



            <p> ~ drogas, parafernalia de drogas, incitación al consumo o venta de las mismas.</p>



            <p> ~ autolesión o suicidio</p>



            <p> ~ actos de violación, incesto, violencia, agresión sexual, tortura, sadomasoquismo extremo, fisting extremo, mutilación de cualquier tipo, necrofilia, zoofilia, pedofilia.</p>



            <p> ~ que contenga materiales escatológicos, relacionado con orina o excrementos.<strong></strong></p>



            <p><strong> </strong>~ pornovenganza o pornografía de venganza, entendida como cualquier material sexualmente explícito que muestre a cualquier persona que no haya dado su consentimiento previo, expreso y escrito para que ese material sea tomado, capturado, o se publique en HOTMY.<strong></strong></p>



            <p> ~ prostitución, servicio de acompañantes, trata de personas.</p>



            <p>iii. material con contenido sexual o lenguaje sexuaal que implique a otro usuario o persona, sin su consentimiento, o cuya imagen haya sido manipulada o modificada digitalmente incluye deepfakes.</p>



            <p>iv. material que contenga discursos que inciten al odio con el fin de vilipendiar, humillar, deshumanizar, cosificar, excluir, atacar, amenazar, perseguir a otro individuo o grupo de personas en razón de su raza, etnia, nacionalidad, orientación sexual, religión, etnia, casta, sexo, identidad de género, discapacidad, enfermedad, o cualquier otra caracteristica.</p>



            <p>v. se refiera o indique datos personales o confidenciales, sin consentimiento expreso y escrito de la persona de referencia.<strong></strong></p>



            <p>vi. material cuyo contenido:</p>



            <p> ~ trate de escenas imágenes o grabaciones de desnudez pública, las cuales hayan sido generadas en ciudades, provincias o países en donde la desnudez pública configure un delito.</p>



            <p> ~ trate de contenido que implique actividad sexual, y haya sigo grabado o transmitido desde un lugar público en donde, sean razonablemente probable que los miembros del público o comunidad vean la actividad que se realiza ejemplo plaza, playa, templo sagrado, etc.</p>



            <p> ~ material que dé la impresión o falsa certeza de que el mismo proviene o está aprobado, autorizado, producido o respaldado por HOTMY.</p>



            <p> ~ implique o promueva actividades comerciales o ventas de terceros, como concursos, sorteos y otras promociones de ventas, colocación de productos, publicidad o anuncios de empleo.<strong></strong></p>



            <h2>3. b Sanciones</h2>



            <p> Es nuestra política suspender el acceso a cualquier Contenido que publiques en Hotmy del que tengamos conocimiento y pueda incumplir con nuestros Términos y Condiciones de uso.</p>



            <p>Tenemos derecho a suspender o cancelar tu cuenta en caso de violaciones reiteradas de estos Términos y Condiciones de uso y/o cualquier ley aplicable.</p>



            <p>Podemos, pero no estamos obligados a moderar o revisar tu Contenido para verificar el cumplimiento de las Términos y Condiciones de Servicio y / o cualquier ley aplicable.</p>



            <p>Si suspendemos el acceso a cualquiera de tu Contenido, podés solicitar una revisión de nuestra decisión de suspender el acceso al Contenido relevante poniéndote en contacto con nosotros a través de info@hotmy.app. Después de nuestra investigación de la sospecha de incumplimiento o ilegalidad del Contenido relevante, podemos tomar cualquier acción que consideremos apropiada, incluso para restablecer el acceso al Contenido o para eliminar o deshabilitar permanentemente el acceso al Contenido relevante sin necesidad de obtener ningún consentimiento de tu parte y sin avisarte previamente. Aceptás que, a tu propio costo, nos brindarás sin demora toda la asistencia razonable incluso proporcionándonos copias de cualquier información que solicitemos en nuestra investigación. No seremos responsables de ninguna pérdida que sufras derivada de la suspensión del acceso a tu Contenido o de cualquier otro paso que tomemos de buena fe para investigar cualquier sospecha de incumplimiento o ilegalidad de tu Contenido según esta sección.</p>



            <p>Si suspendemos el acceso a tu Contenido o lo eliminamos, te lo notificaremos por correo electrónico o mensaje electrónico a tu cuenta de <strong>Hotmy</strong>, pero no estamos obligados a notificar previamente dicha eliminación.</p>



            <p>Nos reservamos el derecho, a nuestra entera discreción, de rescindir tu acuerdo con nosotros y tu acceso a Hotmy por cualquier motivo, notificándote con 10 días de anticipación por correo electrónico o mensaje electrónico a tu cuenta de Hotmy. También podemos suspender el acceso a tu cuenta de usuario o rescindir tu acuerdo con nosotros y tu acceso a inmediatamente y sin previo aviso cuando:</p>



            <ul><li>creemos que has infringido o podés haber infringido grave o repetidamente alguna parte de los Términos y Condiciones de servicio, o si intentas o amenazas con infringir cualquier parte de los Términos y Condiciones de servicio de una manera que pueda tener consecuencias graves para nosotros u otro Usuario;</li><li>realizas alguna acción que, en nuestra opinión, haya causado o sea razonablemente probable que nos haga sufrir una pérdida o que de otro modo dañe la reputación de Hotmy.</li></ul>



            <p>Si suspendemos el acceso a tu cuenta de usuario o rescindimos tu acuerdo con nosotros y tu acceso a Hotmy, te lo haremos saber. Durante cualquier período en el que se suspenda el acceso a tu cuenta de usuario, se suspenderán todos los Pagos de Visualizadores que de otro modo se habrían vencido durante el período de suspensión, y podemos retener la totalidad o parte de las Ganancias de Creador que se te adeuden pero que aún no se hayan pagado.</p>



            <p>Tras la cancelación de tu cuenta, podemos utilizar tu contenido o incluso eliminarlo y ya no tendrás derecho a acceder a tu Contenido. No existe ninguna función técnica en Hotmy para que puedas acceder a tu Contenido después de la cancelación de tu cuenta.</p>



            <p>Podemos investigar cualquier presunto mal uso, abuso o uso ilegal de Hotmy y cooperar con las agencias de aplicación de la ley en dicha investigación.</p>



            <p>Podemos divulgar cualquier información o registros que tengamos o controlemos sobre su uso de Hotmy a las agencias policiales en relación con cualquier investigación policial de cualquier actividad ilegal presunta o presunta, o en respuesta a una orden judicial.</p>



            <h2>3. c Pagos</h2>



            <p> 1. Pagos a los creadores:</p>



            <p>a. Todos los pagos de Visualizadores serán recibidos por un proveedor de pagos externo aprobado por nosotros.</p>



            <p>b. Hotmy recibirá el pago del Visualizador en su totalidad del proveedor o pasarela de pago pago correspondiente. Deduciremos Nuestra Tarifa del Pago de Visualizador y luego retendremos las Ganancias del Creador en su nombre en nuestra capacidad como su agente.</p>



            <p>c. Tu cuenta de Hotmy se actualizará dentro de un tiempo razonable con tus Ganancias de Creador. Tus Ganancias de creador estarán disponibles para que las retires de tu cuenta de Hotmy una vez que dichas Ganancias de creador aparezcan en tu cuenta de Hotmy como Dinero Disponible.</p>



            <p>d. Para realizar un retiro de las ganancias del creador de tu cuenta Hotmy, debe tener al menos el monto mínimo de pago en tu cuenta Hotmy. Hace clic en la página de Extracciones, botón Extraer Dinero de tu cuenta para ver cuál es el monto de pago mínimo según la billetera Local o internacional y opción de pago.</p>



            <p>e. La cantidad que ve en tu Dinero Disponible en tu cuenta de Hotmy es tu Ganancia de Creador que podes retirar según el apartado anterior. Los pagos de los visualizadores y las ganancias de los creadores se realizan en Moneda Internacional USD o la moneda local de tu país. El tipo de cambio aplicable a tu país es controlado por los servicios de Hotmy.</p>



            <p>f. Los retiros o extracciones de dinero son exclusivas a cuentas de plataformas de pago del creador.</p>



            <p>g. Hotmy permite el cambio de divisa o conversión de dinero disponible de tu billetera Internacional a tu Moneda Local mediante la aplicación.</p>



            <p>h. Tu plataforma de pago donde alojas la cuenta de extracción podrá cobrarte tarifas de conversión o transferencia de moneda para recibir el dinero. Además, tu compañía de billetera electrónica puede cobrarte una tarifa por acceder al dinero. No tenemos control sobre los tipos de cambio de divisas o los cargos impuestos por tu banco o tu compañía de billetera electrónica, y no somos responsables de pagar ningún cargo impuesto por tu compañía de billetera electrónica.</p>



            <p>i. Si un Fan busca con éxito un reembolso o una devolución de cargo de su proveedor de tarjeta de crédito con respecto a un Pago de Visualizador, podemos investigar y podemos decidir deducir de tu cuenta una cantidad equivalente a las Ganancias del Creador obtenidas por vos sobre la cantidad devuelta o reembolsada.</p>



            <p>j. Hotmy no almacena ningún dato revelado por vos cuando registras tus Opciones de pago con un proveedor de pago externo.</p>



            <p>2. Circunstancias en las que podemos retener las ganancias del Creador:</p>



            <p>a. Es posible que retengamos la totalidad o parte de las Ganancias del Creador que se le adeuden pero que aún no se hayan pagado:</p>



            <ul><li>si creemos que has infringido o puedes haber infringido grave o repetidamente alguna parte de los Términos y Condiciones de servicio;</li><li>si intentas o amenazas con violar cualquier parte de los Términos y Condiciones de servicio de una manera que creemos que tiene o podría tener consecuencias graves para nosotros o para otro Usuario incluida la pérdida real o posible que nos haya causado a nosotros o a otro Usuario;</li><li>si sospechamos que la totalidad o parte de las Ganancias del Creador resultan de una actividad ilegal, ya sea tu parte o del Visualizador que realizó el Pago de Visualizador que resultó en las Ganancias del Creador durante el tiempo que sea necesario para investigar la infracción real, o la presunta actividad ilegal según corresponda. Si después de nuestra investigación, llegamos a la conclusión de que i ha incumplido grave o repetidamente cualquier parte de los Términos de servicio; ii ha intentado o amenazado con violar cualquier parte de los Términos de servicio de una manera que tiene o podría tener consecuencias graves para nosotros u otro Usuario incluida la pérdida real o posible causada a nosotros oa otro Usuario, y / o  iii las ganancias del creador son el resultado de una actividad ilegal, es posible que le notifiquemos que ha perdido sus ganancias del creador.</li></ul>



            <p>b. No tendremos ninguna responsabilidad ante usted si retenemos o perdemos cualquiera de sus Ganancias de Creador cuando tengamos derecho a hacerlo en virtud de estos Términos de uso.</p>



            <p>c. Si retenemos la totalidad o parte de las Ganancias del Creador que se te adeudan y determinamos que parte de las Ganancias del Creador retenidas por nosotros no está relacionada con el incumplimiento por tu parte de los Términos y Condiciones de servicio o la sospecha de actividad ilegal, entonces podemos pagarte las Ganancias del Creador que determinamos que no están relacionadas con incumplimientos por tu parte de los Términos y Condiciones de servicio o sospecha de actividad ilegal. Sin embargo, aceptas que si consideramos que tu s incumplimiento s de los Términos y Condiciones de servicio nos ha causado o puede causarnos una pérdida, podemos retener todas las Ganancias del Creador que se te adeuden pero que aún no se hayan pagado y podemos compensar dichos montos con las pérdidas sufridas. por nosotros.</p>



            <p>d. Una vez que hayamos terminado nuestra investigación, determinamos que se perderán las Ganancias del Creador, haremos todo lo posible para devolver a los Pagos de los Visualizadores que los realizaron. Los visualizadores tendrán un plazo de 24 hs para reclamar la devolución del dinero a partir del momento de la baja del material multimedia o baja de perfil o envío de regalo.</p>



            <h2>3. d Obligaciones del creador de contenido/HOTMER</h2>



            <p>Desde el momento de tu suscripción a HOTMY, recaen sobre vos las siguientes obligaciones:</p>



            <p>~ A respetar los términos de registración conforme los puntos 2. a y 2. b y 2. c.</p>



            <p>~ A cumplir tu compromiso conforme el apartado 2. e</p>



            <p>~ A no publicar contenido que infrinja las pautas del apartado 3. a “Material Prohibido”.</p>



            <p>~ A revisar periódicamente en la aplicación para mantenerte notificado de las novedades.</p>



            <h2>3. e Derechos del creador de contenido</h2>



            <p>Como CREADOR de contenido de HOTMY, gozarás de derechos como:</p>



            <p>i. Acceder libremente a tu feed, siempre que tu cuenta no se encuentre suspendida por los motivos del <em>apartado 3. b.</em></p>



            <p>ii. Recibir los pagos por la suscripción a tu contenido por parte de los visualizadores, o compra de packs o contenido específico y regalos.</p>



            <p>iii. Subir cualquier material, siempre que no viole nuestras políticas – <em>ver punto 3. a –</em>.</p>



            <p>iv. A saber que el material que subas a HOTMY es de tu exclusiva propiedad, sin embargo, autorizas a HOTMY a tener tu contenido en la app ya sea para ofrecer tu material, como así para promocionar la app.</p>



            <h1>4. Términos de uso de los “visualizadores”</h1>



            <h2>4. a Abonos</h2>



            <p>i. Todas las transacciones e interacciones quedan aplicadas bajo los términos expuestos en este documento. Aunque facilitamos transacciones e interacciones entre Visualizadores y Creadores, la plataforma de Hotmy puede almacenar Contenido y actuar como intermediario de pago sin ser parte del acuerdo vigente o cualquier otro contrato que pueda existir entre un Visualizador y un Creador, y no somos responsables de ninguna transacción o interacción entre ellos.</p>



            <p>ii. Los Creadores son los únicos responsables de determinar dentro de los parámetros de precios de Hotmy los precios aplicables a las transacciones e interacciones y el Contenido al que se le puede dar acceso. Todos los precios aparecen en USD únicamente, pero son convertidos para el usuario a su moneda local en caso de que corresponda.</p>



            <p>iii. Los pagos de los Visualizadores incluyen los tax de las pasarelas de pago determinados por Hotmy en cada caso.</p>



            <p>iv. Para ver el Contenido de un Hotmer, debe hacer click en el botón ‘Suscribirse’ de uso general en la aplicación sobre el perfil o el botón ‘Desbloquear’ aplicado sólo cuando se ingresa a visualizar el perfil de un Hotmer determinado.</p>



            <p>v. Nos autorizas a proporcionar los detalles de tu tarjeta de pago a un proveedor de pago externo con el fin de procesar tu Pago de Visualizador. Todos los pagos de Visualizadores se verán reflejados en USD. El proveedor de tu tarjeta de pago puede cobrarte tarifas de conversión de moneda. No tenemos control sobre los tipos de cambio de divisas o los cargos impuestos por el proveedor de tu tarjeta de pago o el banco y no somos responsables de pagar los cargos o tarifas impuestos por el proveedor de su tarjeta de pago o banco.</p>



            <p>vi. Si eliges proporcionar detalles de dos o más tarjetas de pago, si intentás realizar un pago de Visualizador desde la primera tarjeta y ésta es rechazada por cualquier motivo, la segunda tarjeta será utilizada para cobrar el Pago completo.</p>



            <p>vii. El proveedor de pagos tomará:</p>



            <ul><li>pagos mensuales de tu tarjeta de pago para los pagos de Suscripciones;</li><li>pagos inmediatos desde tu tarjeta de pago para Pagos de Visualizadores ad hoc, como el uso de la función de interacción en la cuenta de un Creador o el pago de una propina al HOTMER. Vos autorizas y das tu consentimiento para que cada uno de estos pagos se cargue utilizando los datos de tu tarjeta de pago proporcionada.</li></ul>



            <p>viii. Todas las Suscripciones al perfil de un HOTMER se renovarán automáticamente al final del período de suscripción mensual, excepto si tu tarjeta de pago fue rechazada o si has desactivado la “Renovación automática”, interruptor ubicado en el perfil del Creador correspondiente. Esto significa que si deseas dejar de suscribirte al perfil de un Creador y pagar los cargos de suscripción mensual continuos, deberás desactivar el interruptor “Renovación automática” ubicado en el perfil del Creador correspondiente.</p>



            <p>ix. Si cancelás una suscripción, se te limita el acceso total o parcial a la visualización de Contenido de Creador.</p>



            <p>x. Aceptás que no realizarás solicitudes injustificadas de reembolso de ningún HOTMER que sigas, ni solicitudes de devolución de cargo injustificadas de tu proveedor de tarjeta de pago o pasarela de pago en relación con cualquier transacción entre vos y un Creador. Si consideramos que realizás una solicitud de reembolso o devolución de cargo de mala fe, tenemos derecho a suspender o eliminar tu cuenta de usuario.</p>



            <h2>4. b Acceso al material</h2>



            <p>Como VISUALIZADOR, si te suscribís mensualmente, vas a poder desbloquear el perfil del HOTMER, accediendo al material cargado tanto en el feed de fotos como en el de videos.</p>



            <p>Finalizado el plazo de suscripción, se renovará automáticamente, salvo que hayas bloqueado dicha función, caso en el cual el perfil del HOTMER será bloqueado nuevamente y no tendrás acceso al material.</p>



            <p>Si comprás un PACK, podrás ver el contenido del mismo por tiempo indefinido. Sin embargo, desde HOTMY tenemos la potestad de cambiar estos términos, comunicándolo por los medios habilitados al efecto, cuando lo considere necesario.</p>



            <p>Todo el material al que accedas, de cualquiera de las dos formas – suscripciones o packs- no es de tu propiedad, por lo que sólo podrás disfrutarla dentro de la aplicación.</p>



            <h2>4. c Prohibiciones</h2>



            <p> Queda terminantemente prohibido realizar las siguientes acciones:</p>



            <p>~ Divulgar por cualquier medio el material contenido en la aplicación.</p>



            <p>~ Tomar capturas o fotos del material contenido en la aplicación.</p>



            <p>~ Realizar cualquier tipo de acción que pueda ocasionar algún perjuicio y/o daño a algún Creador o a Hotmy.</p>



            <h2>4. d Sanciones en caso de violaciones a las prohibiciones.</h2>



            <p> En caso de que vulneres alguna de las normas de estos Términos y Condiciones de Servicio, se te aplicarán las sanciones pertinentes del <em>punto 3. b.</em></p>



            <h2>4. e Obligaciones del visualizador</h2>



            <p>~ A revisar periódicamente la aplicación para mantenerte notificado de las novedades.</p>



            <p>~ A no realizar ninguna de las acciones prohibidas.</p>



            <p>~ A respetar los términos del <em>apartado 2. e.</em></p>



            <h2>4. f Derechos del Visualizador</h2>



            <p>Como Visualizador, tendrás derecho a:</p>



            <p>~ acceder a aquel material multimedia por el cual hayas abonado una suscripción o pack, conforme las condiciones del mismo.</p>



            <p>~ a que se restituya el dinero en los casos del <em>apartado 3 c 2.d.</em></p>



            <p>~ A tener disponible una opción de pago.</p>



            <h1>5. Relaciones externas con Hotmy</h1>



            <h2>5. a Enlaces</h2>



            <p>– Enlaces a Hotmy:</p>



            <p>Podés vincular a la página de inicio de HOTMY, siempre que lo hagas de una manera que sea justa y legal y no dañe nuestra reputación ni se aproveche de ella, pero no debes establecer un vínculo de tal manera que sugiera cualquier forma de asociación, aprobación o respaldo de nuestra parte.</p>



            <p>Si sos un Hotmer, al promocionar tu cuenta de Hotmer, debes cumplir con nuestros Términos y Condiciones de servicio y los términos de servicio de cualquier otro sitio web donde coloques un enlace o promociones tu cuenta Hotmer. Al promocionar tu cuenta de Hotmer, no debes hacerte pasar por Hotmy ni dar la impresión de que promocionamos tu cuenta de Hotmer si este no es el caso. No debes promocionar tu cuenta Hotmy mediante el uso de Google Ads o cualquier plataforma publicitaria similar o servicio de publicidad en motores de búsqueda.</p>



            <p>– Enlaces de Hotmy:</p>



            <p>Si Hotmy contiene enlaces a otros sitios y recursos proporcionados por terceros, estos enlaces se proporcionan sólo para su conveniencia. Dichos enlaces no deben interpretarse como una aprobación por nuestra parte de esos sitios web vinculados o información que pueda obtener de ellos. No tenemos control sobre el contenido de esos sitios o recursos y no aceptamos responsabilidad por ellos o por cualquier pérdida o daño que pueda surgir por su uso de ellos. Si decides acceder a cualquiera de los sitios web de terceros vinculados a Hotmy, lo haces bajo tu propio riesgo y sujeto a los términos y condiciones de uso de dichos sitios web.</p>



            <h2>5. b Términos del programa de Referidos</h2>



            <p><strong>– </strong>Introducción:</p>



            <p>Estos Términos del programa de referidos son términos adicionales que se aplican si utilizas el Programa de referidos de Hotmy y forman parte de tu acuerdo con nosotros.</p>



            <p>– Interpretación:</p>



            <p>En estos Términos del Programa de Referidos, los términos definidos tienen el mismo significado que se les da en los Términos de uso para todos los Usuarios – VER PUNTO 1. e-. Además:</p>



            <p>“Usuario Referente ” también se denomina ” usted ” o ” su ” o “tu” en estos Términos del Programa de Referencias;</p>



            <p>“Hotmer referido” significa la persona que se une a Hotmy como Hotmer a través del enlace de referidos único del Usuario referido.</p>



            <p>– ¿Qué es el Programa de referidos de Hotmy?</p>



            <p>Hotmy ofrece un programa de referidos mediante el cual los usuarios existentes pueden presentar a las personas interesadas en convertirse en Hotmers, a Hotmy y recibir pagos por recomendación de Hotmy, que se calculan y limitan según se describe en la Reglas del programa de referidos.</p>



            <h2>5. c Reglas del programa de Recomendación Hotmy</h2>



            <ol type="i"><li>Solo los usuarios de Hotmy con una cuenta de usuario actual pueden participar en el Programa de Referidos de Hotmy.Si la cuenta de un Usuario ha sido suspendida o cancelada por nosotros por cualquier motivo o si el Usuario la ha eliminado, ese Usuario no será elegible para participar en el Programa de Recomendación de Hotmy.</li><li>Necesitarás una cuenta de usuario del tipo Hotmer Modelo, Fotógrafo, Agencia y una cuenta en las pasarelas de pago para recibir pagos de referencia bajo el Programa de referencia Hotmy.</li><li>Cada usuario tiene un enlace/código de referidos único al que se puede acceder a través de la cuenta de usuario y este puede compartir con otros.Al compartir tu enlace de referido único, no debes hacerte pasar por Hotmy, ni dar la impresión de que compartimos o promocionamos tu enlace de referido.No debes utilizar Google Ads ni ninguna plataforma de publicidad similar o servicio de publicidad de motor de búsqueda para compartir o promocionar tu enlace de referencia único.A petición nuestra, debes revelar los métodos mediante los cuales compartís su enlace de referencia único en el campo Bio / Sitio web de tu cuenta de Hotmy.</li><li>El Hotmer referido debe hacer clic en tu enlace de referido único y luego registrarse con Hotmy, utilizando el mismo navegador que utilizó para hacer clic en tu enlace de referido único.Si alguien se registra en Hotmy de otra manera que no sea mediante tu enlace de referencia único, no vincularemos esa cuenta a tu referido y no te haremos ningún pago por referido.</li><li>El Hotmer referido no debe haber abierto una cuenta de usuario con Hotmy ya sea con el mismo nombre o con otro nombre antes de hacer clic en tu enlace de referido único.Si el Hotmer referido es actualmente o ha sido un Usuario de Hotmy, no te haremos ningún pago por la recomendación realizada.</li><li>No te pagaremos ningún pago por referido sobre ninguna referencia de un Hotmer recomendado que determinemos que es de tu propiedad o está operado por vos, o que tiene una relación comercial con vos.Proporcionarás cualquier información que te solicitemos para permitirnos determinar si el Hotmer recomendado es de tu propiedad o está operado por vos o si existe una relación comercial entre vos y el Hotmer Referido.</li><li>Aceptás que al promocionar Hotmy de alguna manera como Usuario Referido:<ol><li>no darás una falsa impresión de Hotmy, los servicios, programas y contenido incluido el Contenido disponibles a través de Hotmy, sus Usuarios o los Términos de servicio;y</li></ol><ol><li>no harás ninguna declaración que sugiera a un Hotmer potencial que el Hotmer potencial ganará una suma particular de dinero o cualquier dinero por su uso de Hotmy, o cualquier declaración sobre el número probable de Visualizadores.</li></ol></li></ol>



            <h2>5. d Pagos por recomendación</h2>



            <p><em>– ¿Cómo se calculan los pagos por referidos?: </em>Una vez que un “Hotmer referido” se haya convertido en Usuario registrado de Hotmy, de acuerdo con las reglas del punto 5. d, le abonaremos al “Usuario referente” un pago por recomendación equivalente al cinco por ciento 5% de los Pagos de visualizadores generados durante los doce meses posteriores a la fecha de registración en Hotmy por el “Hotmer referido” correspondientes a suscripciones, hasta un monto máximo de u$s 10.000 por Hotmer referido.</p>



            <p> Esto aplica para todas las referencias realizadas antes del 12 de Diciembre de 2021.</p>



            <p><em>– Elegir un método de pago para recibir pagos por referidos:</em> para poder recibir pagos por referidos, primero debe elegir uno de los métodos de pago proporcionados por Hotmy en su país de residencia.</p>



            <p>– <em>¿Con qué frecuencia se realizan los pagos por referencias?:</em> Transferiremos a su cuenta de Hotmy el pago por referido 30 días después de que el pago del visualizador fue percibido.</p>



            <p>– <em>¿Quién corre con el costo del pago de la referencia?</em>: El costo del pago de la referencia corre a cargo de nosotros, no del Creador recomendado.</p>



            <h2>5. e Nuestros derechos relacionados con el programa de recomendación</h2>



            <ol type="i"><li>Si los pagos por recomendación se han realizado incorrectamente, habiendo nosotros pagado sumas de más, tenemos derecho a recuperar dichas sumas del Usuario a quien se abonó incorrectamente, reteniéndolas de pagos futuros.</li><li>Podemos solicitar a vos o a los Hotmers recomendados o ambos que nos proporcionen una identificación y/u otra información que razonablemente necesitemos para verificar cualquier pago de referencia que se realice y la persona a quien se debe realizar dicho pago. El no proporcionar cualquier información solicitada por nosotros puede llevarte a perder tu derecho a los pagos de referencia con respecto al Creador referido relevante.</li><li>Podemos cambiar cualquier aspecto del Programa de referencias de Hotmy incluida la forma en que se calculan los pagos de referencias o interrumpir el Programa de referidos de Hotmy en cualquier momento. Pero ningún cambio privará a ningún Usuario referente de los pagos de referidos ya ganados, en función de los Pagos de los visualizadores antes de la entrada en vigor de los cambios entraron en vigor.</li><li>A suspender o cancelar cuentas conforme apartado 4. d sin previo aviso.</li><li>A colaborar con las autoridades judiciales o administrativas por el mal uso o comisión de algún delito, sin notificación previa.</li><li>A poner a disposición de las legítimas autoridades administrativas o judiciales de tu país, los datos disponibles en nuestra base de datos.</li><li>A cambiar los medios de pago disponibles, según nuestro criterio, notificando ello por intermedio de la aplicación.</li><li>A transferir por cualquier título la propiedad de HOTMY a terceros, en cuyo caso se transferirán los derechos y obligaciones en virtud de tu acuerdo con nosotros. Además, podemos optar por delegar el cumplimiento de cualquiera de nuestras obligaciones en virtud de tu acuerdo con nosotros a cualquier tercero, pero seguiremos siendo responsables por el cumplimiento de dichas obligaciones.</li></ol>



            <h1>6. Nosotros</h1>



            <h2>6. a Jurisdicción en caso de disputas</h2>



            <p> Desde Hotmy, nos encontramos a disposición para colaborar con las autoridades judiciales y/o administrativas que requieran información y/o datos disponibles en nuestras bases. No estamos obligados a prestar colaboración con entidades privadas. Asimismo, ante cualquier reclamo judicial, la jurisdicción competente para entender en conflictos que pudieran surgir a raíz o como consecuencia de este contrato o entre miembros y nosotros, se regirán por las normas de la República de Argentina, y aquellas plasmadas en Tratados Internacionales con jerarquía constitucional ratificados por Argentina.</p>



            <p>Igualmente, los Tribunales judiciales competentes para entender cualquier tipo de reclamo que surja entre las partes del presente, serán los Tribunales Federales de la Ciudad Autónoma de Buenos Aires o los Juzgados Nacionales de la Ciudad Autónoma de Buenos Aires, según corresponda en razón de la materia, renunciando expresamente a la prórroga de jurisdicción.</p>



            <h2>6. b Cargas impositivas</h2>



            <p> Nosotros no somos responsables por aquellos delitos de evasión impositiva en los que puedan incurrir CREADORES o VISUALIZADORES.</p>



            <p> Queda exclusivamente bajo tu responsabilidad, la obligación de cumplir con las cargas tributarias aplicables en tu país.</p>



            <p>Asimismo, solo vos serás responsable por asesorarte con un especialista en la cuestión impositiva, que te informe los pasos a seguir a los fines de tributar conforme la ley de tu país.</p>



            <h2>6. c ¿ De qué no somos responsables?</h2>



            <p>Desde HOTMY no nos responsabilizamos por:</p>



            <p>i. La falsedad en la declaración de tus datos personales.</p>



            <p>ii. Por la falsificación, plagio, o utilización sin licencia de las imágenes que subas como propias ni los delitos en los que puedas llegar a incurrir por ello.</p>



            <p>iii. Tampoco seremos responsables por las denuncias que puedan recaer sobre vos en caso de utilizar contenido que no sea propio, o por utilizar lenguaje inapropiado, o ejercer bullying, acoso, violencia, o cualquier otra conducta agraviante que puedas tener con algún otro miembro de esta comunidad.</p>



            <p>iv. Nosotros no emitimos juicios de valor, ni tomaremos partido de discusiones o debates entre creadores, visualizadores, o usuarios.</p>



            <p>v. No seremos responsables en caso de que utilices los “comentarios” para acordar encuentros con otras personas y de lo que ello pueda resultar.</p>



            <p>vi. No somos responsables de los acuerdos celebrados entre HOTMERS y personal que haya participado o colaborado en la elaboración de contenido fotógrafos, maquilladores, estilistas, etc.</p>



            <p>vii. No somos responsables por la evasión impositiva en la que puedan incurrir HOTMERS o VISUALIZADORES.</p>



            <p>viii. No somos responsables de las consecuencias económicas, jurídicas, psicológicas, personales, laborales o familiares en las que puedan incurrir HOTMERS, VISUALIZADORES o USUARIOS debido al uso de la aplicación.</p>



            <p>ix. No somos responsables de las consecuencias derivadas de la falsedad de datos declarados, falsificación o usurpación de identidad en la que puedan incurrir HOTMERS, VISUALIZADORES o USUARIOS</p>



            <h2>6. d Protección de datos personales</h2>



            <p> Se entiende por <em>datos personales cualquier</em> información que pueda referirse a una persona determinada o determinable, desde el nombre y apellido, hasta una imagen o grabación de voz, siempre que permita reconocer a una persona.</p>



            <p> Todos los datos proporcionados por vos desde el momento de la registración, serán protegidos en archivos seguros.</p>



            <p> Solo utilizaremos los datos con fines estadísticos, y en aquellos casos expresados en el presente acuerdo de Términos y Condiciones, con fines promocionales o de publicidad, con los cuales prestás total conformidad. Los datos por vos proporcionados a HOTMY son confidenciales, y son los indispensables para el funcionamiento de la aplicación.</p>



            <p> No transferiremos tus datos a terceros. En caso de tener que hacerlo, lo notificaremos con la debida anticipación.</p>



            <p> En todo momento podés escribirnos a <a href="mailto:info@hotmy.app">info@hotmy.app</a> para consultar sobre tus datos disponibles, solicitar su supresión – siempre que ello no intervenga con la finalidad de la aplicación- modificación o actualización.</p>



            <p> Terminada nuestra relación, por baja de servicio o cualquier otro motivo que implique nuestra desvinculación, tus datos serán eliminados de nuestros archivos.</p>



            <h2>6. e Nuestros derechos…</h2>



            <p>Nosotros nos reservaremos los siguientes derechos:</p>



            <p>i. A promocionar o visualizar en HOME o en cualquier otro espacio dentro de la aplicación, o incluso en otras Redes Sociales, aquellos perfiles de HOMERS que consideremos convenientes, sin estar obligados a dar explicaciones por ello.</p>



            <p>ii. A publicar el HOME de aquellos perfiles destacados por tener buenas estadísticas de creación de contenido, calidad, ingresos, sin sanciones, o según parámetros que consideremos trascendentes para promocionar la app.</p>



            <p>iii. A seleccionar aquel material de HOTMER que más se adecue a nuestras necesidades, y utilizarlo con fines publicitarios, por los medios que consideremos pertinentes publicidad gráfica, redes sociales, televisión, radio, etc, sin requerir autorización previa.</p>



            <p>iv. Al declarar que el contenido proporcionado es de tu propiedad, no estamos obligados a solicitar autorización de quien haya colaborado o participado en su producción, por ejemplo, fotógrafos, maquilladores, vestuaristas, etc, para la publicación del mismo con fines publicitarios.</p>



            <p>v. A reservarnos el derecho de admisión.</p>



            <p>vi. A validar los perfiles que envíen solicitud para ser CREADORES, conforme la oferta, demanda y preferencia de los usuarios de la aplicación y lo que consideremos conveniente, sin estar obligados a dar una motivación específica al respecto.</p>



            <p>vii. Aparte del Contenido que es propiedad de los Creadores o tienen licencia para ellos, todos los derechos sobre Hotmy y todo su contenido, características, bases de datos, código fuente y funcionalidad son propiedad nuestra. Dicho material está protegido por derechos de autor y puede estar protegido por marcas registradas, secretos comerciales y otras leyes de propiedad intelectual.</p>



            <p>viii. Somos los propietarios únicos y exclusivos de todos y cada uno de los datos anonimizados relacionados con tu uso de Hotmy y estos datos anónimos pueden ser utilizados por nosotros para cualquier propósito, incluso con fines comerciales, de publicidad, de desarrollo e investigación.</p>



            <h2>6. f Tipo de cambio</h2>



            <p> En HOTMY utilizamos la unidad económica del <em>dólar estadounidense</em>, para establecer las tarifas.</p>



            <p> En ningún caso seremos responsables por el tipo de cambio en el país de recepción del pago del HOTMER, ni por las retenciones o sanciones que se apliquen, conforme las políticas de dicho país. Cada HOTMER, asume la responsabilidad por sus propios actos.</p>



            <h2>6. g Medios de pago. Demoras</h2>



            <p> Los medios de pago disponibles, según tu país, son PayPal o Mercadopago.</p>



            <p> No somos responsables por las retenciones en concepto de impuestos o comisiones que apliquen dichas plataformas. Tampoco somos responsables por las demoras en los pagos.</p>



            <p>Desde HOTMY no realizamos devoluciones de pagos efectuados erróneamente. Dichos pagos deberán ser reclamados directamente a la plataforma utilizada a tal fin.</p>



            <p>No reembolsaremos los pagos efectuados por arrepentimiento, disconformidad o cualquier otra circunstancia no imputable a nosotros.</p>



            <h1>7. Reclamos o quejas</h1>



            <h2>7. a ¿Cómo realizo un reclamo o queja?</h2>



            <p> Al ser un usuario de Hotmy, tenés acceso a las Políticas de quejas o reportes. Asimismo, en caso de no serlo, igualmente podés alertarnos sobre alguna situación o queja relacionada a nuestra App.</p>



            <p>i. Cómo presentar una queja. Si tenés alguna queja sobre Hotmy o algún contenido que aparece en la aplicación o la conducta de algún usuario, podés enviarnos tu queja a <a href="mailto:info@hotmy.app">info@hotmy.app</a>, detallando tu nombre, datos de contacto -mail o teléfono- descripción de tu reclamo, y si el mismo se relaciona con algún Contenido, detallar la URL del mismo. En el asunto del mail debes respetar la siguiente nomenclatura para que tu queja sea recibida: Queja <em>documento de identidad – nombre completo – nacionalidad.</em></p>



            <p>ej. Queja 58.258.xxx – Carlos Alfonso Álvarez – Brasil</p>



            <p>ii. ¿Qué hacemos luego de recibir tu queja/reclamo?</p>



            <ul><li>Vamos a tomar las medidas que creamos necesarias y apropiadas para investigar tu queja dentro de un plazo que sea apropiado según su naturaleza.</li><li>Si necesitamos más información o documentos, nos comunicaremos para informarte.</li><li>De buena fe, ejecutaremos todas aquellas acciones que consideremos apropiadas para tratar el motivo de la queja/reclamo que hayas planteado. Si la queja versa sobre el Contenido que aparece en Hotmy, y observamos que infringe nuestra política de material prohibido o infringe alguna de nuestras políticas, actuaremos rapidamente para eliminar dicho Contenido.</li></ul>



            <p>iii. No estamos obligados a informarle sobre el resultado de tu queja/reclamo.</p>



            <h2>7. b Quejas injustificadas, abusivas o falsas</h2>



            <p> Si sos usuario de Hotmy, te comprometés compromiso legalmente exigible, a que no presentarás ninguna queja que sea totalmente injustificada, abusiva o de mala fe. Si determinamos que has incumplido esta garantía, podemos suspender o cancelar tu cuenta de usuario.</p>



            <p>Declaro que leí y comprendí todos los <em>Términos y condiciones del servicio.</em></p>




            <label class="container">
                <input type="checkbox" checked="checked" disabled />
                <span>  </span> Declaro que ACEPTO todos los <em>Términos y Condiciones del servicio.</em>
                <span class="checkmark"></span>
            </label>

            <label class="container">
                <input type="checkbox" checked="checked" disabled />
                <span>  </span>Declaro que los datos proporcionados son verdaderos y válidos.
                <span class="checkmark"></span>
            </label>



            <p></p>
        </div>
    )
}